import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ReadonlyField from '../ReadonlyField';
import DateField from '../DateField';
import { resolveValue } from '../../../utils/fields';
import { extendedStateType } from '../../../types';
import { NO_STATE } from '../../../hooks/useExtendedState';

PrivilegedDateField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    dateFormat: PropTypes.string,
    state: extendedStateType,
};

PrivilegedDateField.defaultProps = {
    sufficientReadPrivileges: null,
    value: undefined,
    dateFormat: 'DD.MM.YYYY',
    state: NO_STATE,
};

function PrivilegedDateField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        dateFormat,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    const stringifiedValue = resolvedValue ? resolvedValue.toString() : '';
    let result = null;
    if (canWrite) {
        result = (
            <DateField
                value={value}
                dateFormat={dateFormat}
                state={state}
                {...rest}
            />
        );
    } else if (canRead) {
        result = (
            <ReadonlyField
                value={(
                    stringifiedValue ? moment(new Date(stringifiedValue)).format(dateFormat) : ''
                )}
                state={state}
                {...rest}
            />
        );
    }
    return result;
}

export default PrivilegedDateField;
